<template>
    <div>
        <slot name="before" />

        <form class="form avp-form" role="form" @submit.prevent="onSubmit" autocomplete="off">
            <div class="form-row">
                <div class="col-xs-12 col-6">
                    <div class="form-group">
                        <input type="text" name="firstname" id="firstname" class="form-control" required="required"
                               :placeholder="$t('generic.firstname')" maxlength="80" v-model="firstname"/>
                    </div>
                </div>
                <div class="col-xs-12 col-6">
                    <div class="form-group">
                        <input type="text" name="lastname" id="lastname" class="form-control" required="required"
                               :placeholder="$t('generic.lastname')" maxlength="80" v-model="lastname"/>
                    </div>
                </div>
                <div class="col-12" :class="{ 'col-xs-12 col-6': showPhone }">
                    <div class="form-group">
                        <input type="email" name="emailAddress" id="email" class="form-control" required="required"
                               :placeholder="$t('generic.email')" v-model="email" maxlength="200"/>
                    </div>
                </div>
                <div class="col-12" v-if="showPhone">
                    <div class="form-group">
                        <input type="tel" name="phone" id="phone" class="form-control"
                               :placeholder="$t('generic.phone_optional')" v-model="phone" maxlength="20"/>
                    </div>
                </div>
                <div class="col-12" v-if=isNewsletterSignupVisible>
                    <div class="form-group form-check">
                        <input type="checkbox" id="newsletterCheck" v-model="newsletterAccepted" class="form-check-input"/>
                        <i18n path="newsletter.optin_text" tag="label" class="form-check-label" for="newsletterCheck"/>
                    </div>
                </div>
                <div class="form-group col-12 text-center just" :class="{ 'd-flex justify-content-between': $slots.action }">
                    <slot name="action"></slot>

                    <button type="submit" class="btn btn-primary" :disabled="isSending">
                        {{ submitText }}
                    </button>
                </div>
            </div>

        </form>

        <slot name="after" />
    </div>
</template>

<script>
export default {
    name: 'ContactForm',
    data () {
        return {
            firstname: '',
            lastname: '',
            email: '',
            phone: undefined,
            newsletterAccepted: false
        }
    },
    props: {
        submitText: {
            type: String,
            default() {
                return this.$t('generic.send')
            }
        },
        showNewsletterCheckbox: Boolean,
        sendVoucher: Boolean,
        showPhone: Boolean,
        isSending: Boolean
    },
    computed: {
        isNewsletterSignupVisible() {
            let lang = ('' + this.$store.state.locale) || 'de';
            if (lang.length > 2) {
                lang = lang.substring(0, 2);
            }
            let isCzechInstance = location.hostname === 'voucher.animod.cz' || location.search.indexOf('czech=true') !== -1;
            console.log("isNewsletterSignupVisible::isCzechInstance", isCzechInstance);
            console.log("isNewsletterSignupVisible::lang", lang);
            console.log("isNewsletterSignupVisible", (lang === 'de' && !isCzechInstance));
            return lang === 'de' && !isCzechInstance;
        }
    },
    methods: {
        onSubmit() {
            const { firstname, lastname, email, phone, newsletterAccepted, isNewsletterSignupVisible, sendVoucher } = this;
            this.$emit('submit', {
              firstname,
              lastname,
              email,
              phone,
              newsletterAccepted: isNewsletterSignupVisible && newsletterAccepted,
              sendVoucher
            })
        }
    }
}
</script>

